module.exports = __webpack_public_path__ + "static/media/box-gray.af80804b.svg";